import { httpClient } from '@/infra/protocols/http';
import { IProjectDTO } from '@/modules/projects/dtos/project.dto';
import { IProject } from '@/modules/projects/entities/project.entity';
import { ProjectMapper } from '@/modules/projects/mappers/project.mapper';

export async function updateProject(
  params: UpdateProjectService.Params,
  data: UpdateProjectService.Payload,
): Promise<UpdateProjectService.Response> {
  const body = {
    nome: data.name,
    imagem: data.fileName,
    descricao: data.description,
  };

  const response = await httpClient.put<IProjectDTO>(`/v1/projetos/${params.projectId}`, body);

  return ProjectMapper.toPresentation(response);
}

export namespace UpdateProjectService {
  export interface Params {
    projectId: string;
  }

  export interface Payload {
    name: string;
    fileName?: string;
    description: string;
  }

  export type Response = IProject;
}
